var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarketingCampaign(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "marketing-campaign",
    transform: "translate(0 -0.199)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_17423",
    "data-name": "Groupe 17423"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_23949",
    "data-name": "Trac\\xE9 23949",
    d: "M4.9,13.9a2.792,2.792,0,0,1,2-.8v-.3a2.647,2.647,0,0,1,2.6-2.6,3.553,3.553,0,0,1,1,.2,3.09,3.09,0,0,1,1.1-2,3.337,3.337,0,0,1,2.3-.9,3.453,3.453,0,0,1,1.8.5A2.949,2.949,0,0,1,17,9.4l.3.5.7-.2a2.92,2.92,0,0,1,.9-.2,2.775,2.775,0,0,1,2.8,2.7v.3l-.1.5.5.2.6.3a5.3,5.3,0,0,0,.8-2.7,5.121,5.121,0,0,0-5.1-5.1h0a2.2,2.2,0,0,0-.8.1,3.906,3.906,0,0,0-5.3-1.9,4.125,4.125,0,0,0-1.3,1A4.481,4.481,0,0,0,4.7,4,4.357,4.357,0,0,0,2.9,7.5a1.952,1.952,0,0,0,.1.7,4.051,4.051,0,0,0-2.6,5A4.1,4.1,0,0,0,4.1,16v-.1A2.792,2.792,0,0,1,4.9,13.9Z",
    fill: "#494b73",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_23950",
    "data-name": "Trac\\xE9 23950",
    d: "M22.7,13.6l-.6-.3-.5-.2.1-.5v-.2A2.775,2.775,0,0,0,19,9.6h-.1a2.92,2.92,0,0,0-.9.2l-.6.2-.3-.5a3.531,3.531,0,0,0-1.3-1.4A3.085,3.085,0,0,0,14,7.6a3.337,3.337,0,0,0-2.3.9,3.09,3.09,0,0,0-1.1,2,3.553,3.553,0,0,0-1-.2A2.647,2.647,0,0,0,7,12.9v.3A2.973,2.973,0,0,0,5,14a2.518,2.518,0,0,0-.9,2v.1a2.8,2.8,0,0,0,2.8,2.8h9.6L19,21.3a.764.764,0,0,0,.5.2.684.684,0,0,0,.7-.7h0V18.9H21a2.775,2.775,0,0,0,2.8-2.7v-.1A2.727,2.727,0,0,0,22.7,13.6Zm-7.9,3.2c-.1-.1-.1-.1-.1-.2V14.8H10.6a.319.319,0,0,1-.3-.3V13.4a.265.265,0,0,1,.3-.3h4.1V11.3A.265.265,0,0,1,15,11h0c.1,0,.1,0,.2.1l2.9,2.6a.3.3,0,0,1,0,.4h0l-1.9,1.7-1,.9c-.1.3-.3.3-.4.1Z",
    fill: "#494b73"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingCampaign);
export default __webpack_public_path__ + "static/media/marketing-campaign.8666b6c1eaedb5785be39bda2d3fa0f5.svg";
export { ForwardRef as ReactComponent };